import React from "react";
import { Plus } from "lucide-react";
import { AppButton, AppBadge, AppDataTable } from "../ui";

const TestCaseList = ({ testCases = [], onAdd, onEdit, onDelete }) => {
  const columns = [
    {
      key: "num",
      label: "#",
      width: "48px",
      align: "center",
      render: (_tc, index) => index + 1,
    },
    {
      key: "input",
      label: "Input",
      render: (tc) => (
        <pre className="tw-m-0 tw-font-mono tw-text-[0.8125rem] tw-text-content tw-bg-transparent tw-whitespace-pre-wrap tw-break-words">
          {tc.input || <span className="tw-text-content-subtle tw-italic">(empty)</span>}
        </pre>
      ),
    },
    {
      key: "expectedOutput",
      label: "Expected Output",
      render: (tc) => <pre className="tw-m-0 tw-font-mono tw-text-[0.8125rem] tw-text-content tw-bg-transparent tw-whitespace-pre-wrap tw-break-words">{tc.expectedOutput}</pre>,
    },
    {
      key: "isHidden",
      label: "Hidden",
      width: "90px",
      align: "center",
      render: (tc) =>
        tc.isHidden
          ? <AppBadge variant="secondary" size="sm">Hidden</AppBadge>
          : <AppBadge color="emerald" size="sm">Visible</AppBadge>,
    },
    {
      key: "actions",
      label: "Actions",
      width: "130px",
      align: "right",
      className: "tw-whitespace-nowrap",
      render: (tc) => (
        <div className="tw-inline-flex tw-gap-1.5">
          <AppButton size="xs" variant="outline" onClick={() => onEdit(tc)}>Edit</AppButton>
          <AppButton size="xs" variant="outline-destructive" onClick={() => onDelete(tc._id)}>Delete</AppButton>
        </div>
      ),
    },
  ];

  return (
    <div className="tw-flex tw-flex-col tw-gap-3.5">
      <div className="tw-flex tw-items-center tw-justify-between">
        <h6 className="tw-m-0 tw-text-[0.8125rem] tw-font-semibold tw-text-content-muted tw-uppercase tw-tracking-[0.05em]">
          Test Cases
        </h6>
        <AppButton size="sm" variant="outline" onClick={onAdd}>
          <Plus size={14} />
          <span>Add Test Case</span>
        </AppButton>
      </div>

      {/* `fill={false}` — this table flows inside a form card rather than filling a
          flex-column page, so it must not claim the remaining height. */}
      <AppDataTable
        columns={columns}
        rows={testCases}
        rowKey={(tc) => tc._id}
        fill={false}
        emptyMessage="No test cases yet. Add one to get started."
      />
    </div>
  );
};

export default TestCaseList;
